<template>
  <div>
    <validation-provider
      :name="$t(config.name)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(`commands.form.${config.name}.label`) }}
      </label>
      <v-select
        v-model="model"
        :options="options"
        :clearable="true"
        :reduce="(val) => val.value"
        input-id="alarm_type"
        :multiple="multiple"
        @input="$emit('input', model)"
      />
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";
import store from "@/store";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
    nodeConfig: Object,
  },
  data() {
    return {
      model: null,
      options: [
        {label: 'attending', value: 'attending'},
        {label: 'attended', value: 'attended'},
        {label: 'canceled', value: 'canceled'},
        {label: 'Remover del flujo Maker-Checker', value: 'remove_maker_checker_flow'},
        {label: 'Mover a mantenimiento', value: 'move_to_maintenance'},
        {label: 'Restaurar desde mantenimiento', value: 'remove_from_maintenance'},
      ],
    };
  },
  created() {
    this.model = this.value || null;
  },
  mounted() {
  },
  computed: {
  },
};
</script>

<style></style>
